import { BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';

function App() {
  const isLocal = window.location.hostname === "localhost";
  
  return (
    <BrowserRouter basename={isLocal ? "" : "/lcaas"}>
      <Home />
    </BrowserRouter>
  );
}

export default App;